import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import RestaurantReservationsPage from 'modules/restaurant/reservations/RestaurantReservationsPage';

export default function DashRestaurantReservations() {
    return (
        <DashEstablishmentContainer title='Reservas'>
            <RestaurantReservationsPage />
        </DashEstablishmentContainer>
    );
}
